const getEnv = () => {
  const host = window.location.hostname.toLowerCase();
  
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'development';
  }
  
  return 'production';
};

const ENV = getEnv();
const CONFIG = {
  development: {
    BASE_URL: 'http://localhost:8000',
    EDS_BACKEND_URL: 'http://localhost:8000',
    CHECKPOINTS_URL: 'http://localhost:8000',
    // Validation API (automation /query hits orchestrator on 8000; /automation/* must reach QA-Agent directly)
    QA_AGENT_URL: 'http://localhost:4002',
    ARTIFACTS_URL: 'http://localhost:4001', // DeveloperAgent directly in dev
  },
  production: {
    BASE_URL: 'https://formlift-api.ibeam.optisolbusiness.com',
    EDS_BACKEND_URL: 'https://formlift-api.ibeam.optisolbusiness.com',
    CHECKPOINTS_URL: 'https://formlift-api.ibeam.optisolbusiness.com',
    QA_AGENT_URL: 'https://formlift-api.ibeam.optisolbusiness.com',
    ARTIFACTS_URL: 'https://formlift-api.ibeam.optisolbusiness.com', // via Orchestrator
  },
};
export const networkManager = CONFIG[ENV];
export const networkManagerEnv = ENV;
export { getEnv };
